var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('is-loading'):_vm._e(),(_vm.isError)?_c('loading-error',{attrs:{"errorDetails":_vm.errorDetails},on:{"reload":_vm.load}}):_vm._e(),(!_vm.isLoading&&!_vm.isError)?_c(_vm.nowComponent,{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }